import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { getCookie, useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { onGetAuthInfoThunk, onGetPublicTokenThunk } from './AuthorizationProvider.actions'
import AuthorizationContext from './AuthorizationProvider.context'
import { Root } from './AuthorizationProvider.styles'

/**
 * The Authorization Provider container.
 */
const AuthorizationProvider = ({ children }) => {
  const dispatch = useDispatch()
  const {
    authInfo: { loading: loadingAuthInfo, userType },
    publicToken: { loading: loadingToken }
  } = useSelector(state => state.authorizationProvider)

  const accessToken = getCookie('access_token')

  useEffectOnce(() => {
    if (!accessToken || accessToken === 'undefined') {
      dispatch(onGetPublicTokenThunk())
    }
  })

  useEffectOnce(() => {
    if (accessToken && !loadingAuthInfo) {
      dispatch(onGetAuthInfoThunk())
    }
  }, [accessToken])

  const isPrivated = useMemo(() => {
    return userType === '' ? undefined : userType === 'Comprador' || userType === 'Proveedor'
  }, [userType])

  if (!(accessToken && !loadingToken && userType && !loadingAuthInfo)) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return <AuthorizationContext.Provider value={{ isPrivated, userType }}>{children}</AuthorizationContext.Provider>
}

AuthorizationProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthorizationProvider
